import { defineMessages } from "react-intl";

export default defineMessages({
  superTalentGoal: {
    id: "repeatRate.superTalentGoal",
    defaultMessage:
      "<superTalentBadge></superTalentBadge> Objectif SuperTalent",
  },
  score_value: {
    id: "repeatRate.scoreValue",
    defaultMessage: "{score} %",
  },
  improveScore: {
    id: "repeatRate.improveScore",
    defaultMessage: "Comment améliorer le score",
  },
  seeMore: {
    id: "repeatRate.seeMore",
    defaultMessage: "Voir plus <RightIcon></RightIcon>",
  },
  share_profile: {
    id: "repeatRate.shareProfile",
    defaultMessage: "Partagez votre profil à vos clients",
  },
  respect_rules: {
    id: "repeatRate.respectRules",
    defaultMessage: "Respectez les règles du jeu !",
  },
  how_to_super: {
    id: "repeatRate.howToSuper",
    defaultMessage: "Comment atteindre l'objectif SuperTalent",
  },
  do_jobs: {
    id: "repeatRate.doJobs",
    defaultMessage: "Réalisez des jobs pour atteindre l’objectif SuperTalent",
  },
  ask_questions: {
    id: "repeatRate.askQuestions",
    defaultMessage:
      "Posez les bonnes questions au client ou à la cliente avant qu'il ou elle ne vous choisisse.",
  },
  discover_advice: {
    id: "repeatRate.discoverAdvice",
    defaultMessage:
      "Découvrez nos conseils pour augmenter votre taux de réalisation.",
  },
  share_profile_title: {
    id: "repeatRate.shareProfileTitle",
    defaultMessage: "Partagez votre profil à vos clients",
  },
  share_profile_core: {
    id: "repeatRate.shareProfileCore",
    defaultMessage:
      "Vous retravaillez avec un client mais ne savez pas comment créer un job sur la plateforme ? Partagez votre profil à votre client. Il pourra alors créer une demande uniquement pour vous. A vous de l'accepter ou non.",
  },
  respect_rules_title: {
    id: "repeatRate.respectRulesTitle",
    defaultMessage: "Respectez les règles de jeu !",
  },
  respect_rules_core: {
    id: "repeatRate.respectRulesCore",
    defaultMessage:
      "Vous vous présentez à nouveau chez un client ? Passez toujours via Ring Twice ! Vous respectez ainsi <bold>les règles du jeu.</bold> De plus, le service est <bold>assuré et déclaré.</bold> Si vous passez en dehors, nous pouvons suspendre votre compte.",
  },
  how_to_core: {
    id: "repeatRate.howToCore",
    defaultMessage:
      "Passez via Ring Twice quand vous retravaillez avec un client et celui-ci deviendra un client dit récurrent.L'objectif SuperTalent <bold>dépend de votre catégorie de service.</bold> Cela veut dire que ce seuil est différent en fonction du type de service que vous rendez.",
  },
  share_my_profile: {
    id: "repeatRate.shareMyProfile",
    defaultMessage: "Partager mon profil",
  },
  do_jobs_title: {
    id: "realisationRate.doJobsTitle",
    defaultMessage: "Réalisez des jobs",
  },
  do_jobs_core: {
    id: "realisationRate.doJobsCore",
    defaultMessage:
      "Pour augmenter votre taux de réalisation, il vous faut réaliser des jobs. Tout en évitant les annulations. Si un job devait être annulé, pas de panique. Comme votre taux est basé sur les 12 derniers mois, <bold>une annulation n'a pas d'impact à vie</bold> !",
  },
  ask_questions_title: {
    id: "realisationRate.askQuestionsTitle",
    defaultMessage: "Communiquez avec le client",
  },
  ask_questions_core: {
    id: "realisationRate.askQuestionsCore",
    defaultMessage:
      "Avant que le client/ la cliente vous choisisse, il est important de se mettre d’accord sur : <break></break><break></break>• Pour quand le travail doit-il être réalisé ?Suis-je disponible ?<break></break>• Y-a-t-il du matériel sur place ou est-ce que je dois amener le mien ?<break></break>• Quel est plus ou moins votre budget ?<break></break>• Quelle est la description complète du travail ?",
  },
  discover_advice_title: {
    id: "realisationRate.discoverAdviceTitle",
    defaultMessage: "Une annulation, ça peut disparaitre",
  },
  discover_advice_core: {
    id: "realisationRate.discoverAdviceCore",
    defaultMessage:
      "Le taux de réalisation est basé sur les 12 derniers mois, <bold>une annulation n'a donc pas d'impact à vie</bold> !",
  },
  dateComputed: {
    id: "superTalent.dateComputed",
    defaultMessage: "<calendar></calendar>Calculés sur 12 mois",
  },
  no_information: {
    id: "superTalent.noInformation",
    defaultMessage: "-",
  },
  score: {
    id: "repeatRate.score",
    defaultMessage: "Votre score",
  },
  recurrentClients: {
    id: "repeatRate.recurrentClients",
    defaultMessage: "Clients récurrents",
  },
  totalClients: {
    id: "repeatRate.totalClients",
    defaultMessage: "Clients total",
  },
  closedServices: {
    id: "realisationRate.closedServices",
    defaultMessage: "Jobs clôturés",
  },
  cancelledServices: {
    id: "realisationRate.cancelledServices",
    defaultMessage: "Jobs annulés",
  },
  totalServices: {
    id: "realisationRate.totalServices",
    defaultMessage: "Total de jobs",
  },
  scoreFormula: {
    id: "realisationRate.scoreFormula",
    defaultMessage: "= clôturés ({closed}) ÷ total ({total})",
  },
  blocked: {
    id: "superTalent.blocked",
    defaultMessage:
      "Vous ne pouvez malheureusement plus postuler à cause de votre taux trop faible",
  },
  warning: {
    id: "superTalent.warning",
    defaultMessage:
      "Attention, vous approchez de la limite. Il y a moyen de s'améliorer.",
  },
  ok: {
    id: "realisationRate.ok",
    defaultMessage: "Continuez sur cette lancée !",
  },
  good: {
    id: "realisationRate.good",
    defaultMessage: "Vous êtes si proche du but !",
  },
  excellent: {
    id: "realisationRate.excellent",
    defaultMessage: "SuperTalent en vue !",
  },
  newbie: {
    id: "realisationRate.newbie",
    defaultMessage:
      "Décrochez votre premier job et accédez à votre taux de réalisation !",
  },
  finish_jobs: {
    id: "realisationRate.finishJobs",
    defaultMessage: "Passez à l’action: terminez vos jobs en cours",
  },
  current_jobs_questions: {
    id: "realisationRate.currentJobsQuestions",
    defaultMessage:
      "Candidatures en cours: soyez réactifs et posez les bonnes questions",
  },
  work_previous_clients: {
    id: "realisationRate.workPreviousClients",
    defaultMessage: "Travaillez avec des anciens clients",
  },
  finish_jobs_title: {
    id: "realisationRate.finishJobsTitle",
    defaultMessage: "Terminez vos jobs en cours",
  },
  finish_jobs_core: {
    id: "realisationRate.finishJobsCore",
    defaultMessage:
      "Pour augmenter votre taux de réalisation, clôturez vos jobs en cours si vous en avez. Plus vous clôturez de jobs, plus votre taux augmentera.",
  },
  current_jobs_questions_title: {
    id: "realisationRate.currentJobsQuestionsTitle",
    defaultMessage: "Candidatures en cours",
  },
  current_jobs_questions_core: {
    id: "realisationRate.currentJobsQuestionsCore",
    defaultMessage:
      "Essayez d'être sélectionné pour les jobs auxquels vous avez déjà fait une offre. Soyez réactif et posez les bonnes questions.",
  },
  work_previous_clients_title: {
    id: "realisationRate.workPreviousClientsTitle",
    defaultMessage: "Contactez vos anciens clients",
  },
  work_previous_clients_core: {
    id: "realisationRate.workPreviousClientsCore",
    defaultMessage:
      "Recontactez vos anciens clients via l'onglet Mes clients et proposez-leur de refaire appel à vos services via Ring Twice.",
  },
  selectionsCount: {
    id: "selectionRate.selectionsCount",
    defaultMessage: "Selections",
  },
  offersSentCount: {
    id: "selectionRate.offersSentCount",
    defaultMessage: "Offers sent",
  },
  quality_offers: {
    id: "selectionRate.qualityOffers",
    defaultMessage: "For offers, choose quality over quantity!",
  },
  quality_offers_title: {
    id: "selectionRate.qualityOffersTitle",
    defaultMessage: "For offers, choose quality over quantity!",
  },
  quality_offers_core: {
    id: "selectionRate.qualityOffersCore",
    defaultMessage:
      "There's no need to send out a large number of irrelevant offers. Sending quality offers (that are clear and detailed) significantly increases your chances of being selected. Also, make sure to communicate effectively with the client: reassure them of your ability to do the job and let them know when you're available.",
  },
  follow_feedback: {
    id: "selectionRate.followFeedback",
    defaultMessage: "Follow your clients' feedback closely!",
  },
  follow_feedback_title: {
    id: "selectionRate.followFeedbackTitle",
    defaultMessage: "Follow your clients' feedback closely!",
  },
  follow_feedback_core: {
    id: "selectionRate.followFeedbackCore",
    defaultMessage:
      "Only jobs that have been assigned are taken into account. This means you are not penalised when clients do not reply, and you receive feedback every time your application is declined. By analysing the reasons why your applications have been rejected, you'll be able to identify areas for improvement. Perhaps some information is missing from your profile? Or perhaps you're applying for jobs that are too far from where you live?",
  },
  be_patient: {
    id: "selectionRate.bePatient",
    defaultMessage:
      "Be patient - your selection rate will only go up as you gain more experience on the platform!",
  },
  be_patient_title: {
    id: "selectionRate.bePatientTitle",
    defaultMessage: "Be patient!",
  },
  be_patient_core: {
    id: "selectionRate.bePatientCore",
    defaultMessage:
      "If you're just starting out, don't worry—the first few jobs are the hardest to get. Once you've got a few reviews, your chances of being selected will increase.",
  },
  selectionRateFeedbacksTitle: {
    id: "selectionRate.feedbacksTitle",
    defaultMessage: "Feedbacks from clients",
  },
  selectionRateFeedbacksDesc: {
    id: "selectionRate.feedbacksDesc",
    defaultMessage:
      "You can't be selected all the time – that's normal. But client feedback will <bold>help you improve your offers over time</bold>.",
  },
  selectionRateReportedTimes: {
    id: "selectionRate.reportedTimes",
    defaultMessage: "Reported {count} times",
  },
  remainingEffortRepeatRate: {
    id: "repeatRate.remainingEffort",
    defaultMessage:
      "Based on your current total number of clients, you should bring back <bold>{count} more clients</bold> to reach the objective!",
  },
  remainingEffortRealisationRate: {
    id: "realisationRate.remainingEffort",
    defaultMessage:
      "Based on your current number of closed jobs, you should bring <bold>{count} more jobs</bold> to reach the objective!",
  },
  remainingEffortSelectionRate: {
    id: "selectionRate.remainingEffort",
    defaultMessage:
      "Based on your current number of offers sent, you should get selected <bold>{count} more times</bold> to reach the objective!",
  },
});
